<template>
  <base-loader :loading="loading">
    <div class="rounded-lg shadow-md">
      <ptos-approval-table
        :header="tableHeader"
        :ptos="list"
        :updatingPtos="updatingPtos"
        @approve="approvePto"
        @details="openDetails"
        @reject="rejectPto"/>
      <pagination :pagination="pagination" @input="changePage" v-if="pagination.total"/>
    </div>
  </base-loader>
</template>

<script>
  import PtosApprovalTable from "../../components/ptos/PtosApprovalTable";
  import Pagination from "../../components/Pagination";
  import Ptos from "../../services/Ptos";
  import EventBus from "../../utilities/eventBus";

  export default {
    name: "ApprovePTOs",
    components: {
      PtosApprovalTable,
      Pagination
    },
    data: () => ({
      loading: false,
      list: [],
      pagination: {},
      queryParams: {
        page: 1,
      },
      updatingPtos: []
    }),
    methods: {
      getPtos () {
        this.loading = true;
        Ptos.getAll().then(res => {
          this.list = res.data
        }).catch(error => {
          this.$notificationService.error(error.message)
        }).finally(() => {
          this.loading = false;
        })
      },
      openDetails (pto) {
        EventBus.$emit('ptoDetails', pto)
      },
      approvePto (pto) {
        Ptos.approve(pto.id).then(() => {
          this.changePtoStatus(pto, 'APPROVED')
          this.$notificationService.success(`${this.$t('ptos.pto')} ${this.$t('notification.successApprove')}`)
        }).catch(error => {
          this.$notificationService.error(error.message)
        }).finally(() => {
          this.updatingPtos.splice(this.updatingPtos.indexOf(pto.id))
        })
      },
      rejectPto (pto) {
        Ptos.reject(pto.id).then(() => {
          this.changePtoStatus(pto, 'REJECTED')
          this.$notificationService.success(`${this.$t('ptos.pto')} ${this.$t('notification.successReject')}`)
        }).catch(error => {
          this.$notificationService.error(error.message)
        }).finally(() => {
          this.updatingPtos.splice(this.updatingPtos.indexOf(pto.id))
        })
      },
      search () {
        this.$router.push({query: this.queryParams}).catch(() => {
        })
        this.queryParams.page = 1
        this.getPtos()
      },
      getUrlParams () {
        let vm = this;
        if (this.$route.query.page) {
          vm.queryParams = Object.assign({}, vm.$route.query);
        }
      },
      changePage (newPage) {
        this.queryParams.page = newPage
        this.$router.push({query: this.queryParams}).catch(() => {
        })
        this.getPtos()
      },
      changePtoStatus (selectedPto, newStatus) {
        let ptoIndex = this.list.findIndex((pto) => pto.id === selectedPto.id)
        this.list[ptoIndex].status = newStatus
      }
    },
    computed: {
      tableHeader () {
        return ([
          this.$t('users.table.name'),
          this.$t('users.table.surname'),
          this.$t('ptos.table.start_date'),
          this.$t('ptos.table.end_date'),
          this.$t('ptos.table.status'),
          this.$t('ptos.table.actions')
        ])
      }
    },
    mounted () {
      this.getUrlParams()
      this.getPtos()
      EventBus.$on('ptoStatusChange', () => {
        this.getPtos()
      })
    },
  }
</script>

<style scoped>

</style>
